import api from "../../utils/apiUser";

export const verUnidades = async () => {
  const res = await api.get("/api/unidades_medidas");
  return res.data;
};

export const crearUnidad = async (data) => {
  const res = await api.post("/api/unidades_medidas", data);
  return res.data;
};

export const editarUnidad = async (id, data) => {
  const res = await api.put(`/api/unidades_medidas/${id}`, data);
  return res.data;
};
